// This adds backwards browser compatibility 
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

import './css/styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {OidcProvider, processSilentRenew} from 'redux-oidc';
import { ConnectedRouter } from 'connected-react-router';
import { loadUser } from 'redux-oidc';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import userManager from './userManager';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
loadUser(store, userManager);

const rootElement = document.getElementById('root');
if (window.location.pathname === '/silent-renew' || window.location.pathname === `${process.env.PUBLIC_URL}/silent-renew`) {
  processSilentRenew();
} else {
  ReactDOM.render(
    <Provider store={store}>
      <OidcProvider userManager={userManager} store={store}>
        <ConnectedRouter history={history}>
          <App/>
        </ConnectedRouter>
      </OidcProvider>
    </Provider>,
    rootElement);
}
//registerServiceWorker();
